import * as React from 'react';
import { DevSiteRole, GlobalPermission, UserModel } from 'shared/models/user';
import { CompanyUser } from '../models/orgs';

export interface AuthenticationContextModel {
  user: UserModel;
  isSignedIn: () => boolean;
  isAdmin: () => boolean;
  hasGlobalPermission: (globalPermission: GlobalPermission | GlobalPermission[]) => boolean;
  hasRole: (roleName: DevSiteRole) => boolean;
  refreshUserContext: () => void | Promise<unknown>;
  isSelf: (user: CompanyUser | UserModel) => boolean;
  isWorkdayEmployee: () => boolean;
  hasSignedTerms: boolean;
}

export const defaultAuthContextModel: AuthenticationContextModel = {
  user: undefined!,
  isSignedIn: () => false,
  isAdmin: () => false,
  hasGlobalPermission: () => false,
  hasRole: () => false,
  refreshUserContext: () => undefined,
  isSelf: () => false,
  isWorkdayEmployee: () => false,
  hasSignedTerms: false,
};

/**
 * Context for Authentication, includes the user object, signed in status, and admin status.
 */
const AuthenticationContext = React.createContext<AuthenticationContextModel>(defaultAuthContextModel);

interface PublicProps {
  permission: GlobalPermission | GlobalPermission[];
}

export const HasGlobalPermission: React.FC<React.PropsWithChildren<PublicProps>> = (props) => (
  <AuthenticationContext.Consumer>
    {(authContext) => {
      const { permission } = props;
      const showChildren = !permission || authContext.hasGlobalPermission(permission);
      return showChildren && props.children;
    }}
  </AuthenticationContext.Consumer>
);

export default AuthenticationContext;
